import { comparer, toJS } from 'mobx';
import { Store } from 'bernie-plugin-mobx';

import { LocationReactorResult } from 'bernie-client';

import { DefaultRequestFields } from 'models';

// In a url, an empty array is equivalent to an empty string and a single element array is equivalent to a string of that element
const convertEmptyOrSingleElementArrayToString = (param: any) => {
  if (Array.isArray(param) && param.length < 2) {
    return param.toString();
  }

  return param;
};

export const haveQueryParamChanged = (currentParam: any, newParam: any) => {
  const convertedNewParam = convertEmptyOrSingleElementArrayToString(newParam);
  const convertedCurrentParam = convertEmptyOrSingleElementArrayToString(currentParam);

  return !comparer.structural(convertedCurrentParam, convertedNewParam);
};

type StoreWithDefaultRequestFields = Store & {
  defaultRequestFields: DefaultRequestFields;
};

export const processClientSideDefaultRequestFields = (
  isServer: boolean | undefined,
  store: StoreWithDefaultRequestFields,
  nextQuery?: Record<string, any>
): LocationReactorResult | undefined => {
  const defaultRequestFields = toJS(store.defaultRequestFields) as any;

  let newQuery;

  if (!isServer && defaultRequestFields && Object.keys(defaultRequestFields).length > 0) {
    const validQuery =
      !nextQuery ||
      Object.keys(defaultRequestFields).some(key =>
        Boolean(!nextQuery[key] || haveQueryParamChanged(nextQuery[key], defaultRequestFields[key]))
      );

    if (validQuery) {
      const dialogPattern = /dialog/i;
      const dialogs = Object.fromEntries(
        [...new URLSearchParams(window.location.search).entries()].filter(([key]) => dialogPattern.test(key))
      );
      newQuery = { query: { ...dialogs, ...defaultRequestFields }, replace: true };
    }
    store.defaultRequestFields = {};
  }

  return newQuery;
};
